<template>
    <div :class="[{'py-5 duration-300 my-1.5': focusText || itemSelected != null},{'pb-5 duration-300 my-2.5': !focusText || itemSelected == null}]">
        <div class="relative" :class="[isError ? 'pb-2.5':'']" ref="dropdown-btn">
            <!-- Dropdown btn -->
            <button class="w-full p-2.5 placeholder-a-gray-78787D rounded-10 text-16 border-b"
                    :class="[isError ? 'border-a-red-FF5045' : itemSelected == null ? 'border-a-gray-D9DBDE':' border-a-blue-7db0ff dropdown-btn']"
                    :data-cy="$attrs['data-cy'] || inputLbl.name"
                    @click="toggleDropdown()">

                <div class="text-left text-a-black-000926">{{itemSelected?.text}}</div>
                <div class="block absolute left-2.5 duration-300 pointer-events-none"
                   :class="[{'top-0 text-16': itemSelected == null && !focusText},
                        {'-top-6 text-16 bg-white': itemSelected != null || focusText},
                        {'-top-3 bg-inherit ': isDisable},
                        itemSelected == null ? 'text-a-gray-78787D' : 'text-a-black-000926']">
                    {{inputLbl.name}}
                </div>
            </button>
            <!-- item list -->
            <div v-show="showList && itemList.length > 0"
                 ref="ddl-list-area"
                 class="absolute left-0 w-full bg-white text-a-black-000926 border rounded-lg overflow-hidden z-index-dropdown"
                 :class="[isBottomDropdown ? 'top-10' : 'bottom-16']">
                <div class="max-h-64 overflow-y-auto hide-scroll">
                    <div v-for="(v) in itemList" :key="v.value"
                        class="py-2 px-4 border-b last:border-b-0 cursor-pointer hover:bg-gray-50 text-left text-14"
                        @click="selectItem(v)">
                        {{v.text}}
                    </div>
                </div>
            </div>
            <div v-if="!isError" class="text-a-gray-78787D text-14 px-2.5 pt-2">
                {{inputLbl.placeholder}}
            </div>
            <!-- error msg -->
            <div class="text-a-gray-78787D text-14 relative top-3 left-0 w-full flex items-start gap-2.5" v-if="isError">
                <img src="@/assets/icon/ic-warning-triangle.svg" alt="">
                <div>{{ getErrorMsg }}</div>
            </div>
        </div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Array} itemList (required) list of dropdown item { key: '', value: '' }
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "DropdownAddressBorder",
    props: {
        // v-model
        inputValue:     { type: [String,Number] },
        itemList:       { type: Array, required: true },
        // props
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        isDisable:      { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: this.inputValue,
            showList: false,
            itemSelected: null,

            isBottomDropdown: true,
            focusText: false
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    mounted: function() {
        this.setSelectedDropdown();
        this.validateInput();
    },
    methods: {
        setSelectedDropdown: function() {
            let item = this.itemList.find((obj) => {
                return obj.value == this.content;
            });
            if (item != null) {
                this.itemSelected = item;
            }
        },

        toggleDropdown: function() {
            if (this.showList) {
                this.closeDropdown();
            } else {
                this.openDropdown();
            }
            this.$emit('onClick');
        },
        openDropdown: function() {
            this.isBottomDropdown = true;
            this.showList = true;
            document.addEventListener('click', this.documentClick);

            this.$nextTick(() => {
                let elem = this.$refs['ddl-list-area'];
                let bottom = elem.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight;

                this.isBottomDropdown = bottom < windowHeight;
            });
        },
        closeDropdown: function() {
            this.showList = false;
            document.removeEventListener('click', this.documentClick);
        },
        documentClick: function(e) {
            let el = this.$refs['dropdown-btn'];
            var target = e.target;

			if (el !== target && !el.contains(target)) {
				this.closeDropdown();
			}
        },

        selectItem: function(item) {
            this.content = item.value;
            this.itemSelected = item;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        clearSelect: function() {
            this.content = "";
            this.itemSelected = null;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && this.itemSelected == null) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
        },
        setValue: function(value) {
            this.content = value;
            this.setSelectedDropdown();
            this.validateInput();
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .dropdown-btn {
        background-image: url('../../../assets/icon/ic-arrow-down-blue.svg');
        background-position: center right 15px;
        background-repeat: no-repeat;
        background-size: 12px 7px;
    }
</style>
